import React from 'react';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import NotificationImportantIcon from '@mui/icons-material/NotificationImportant';
import AlarmOnIcon from '@mui/icons-material/AlarmOn';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import EventIcon from '@mui/icons-material/Event';
import EventAvailableIcon from '@mui/icons-material/EventAvailable';
import ScheduleIcon from '@mui/icons-material/Schedule';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
dayjs.extend(utc);
import CountdownTimer from './CountdownTimer';
import {
    Card, CardContent, CardHeader ,
    Button,
    Skeleton,
    Fab,
    Drawer,
    Slide,
    IconButton,
    Radio,
    RadioGroup,
    FormControlLabel,
    FormLabel,
    Fade
}
    from '@mui/material';

import styles from './Scheduler.module.css'; // Import css modules stylesheet as styles

function Scheduler(props) {

    const [selectedDate, setSelectedDate] = React.useState(null);
    const [selectedTime, setSelectedTime] = React.useState(null);
    const scheduleButtonRef = React.useRef(null);
    // we want 3 date options
    let pickup1 = null;
    let pickup2 = null;
    let pickup3 = null;

    const [pickupDate1, setPickupDate1] = React.useState(null);
    const [pickupDate2, setPickupDate2] = React.useState(null);
    const [pickupDate3, setPickupDate3] = React.useState(null);
    const [availableTimes, setAvailableTimes] =  React.useState([]);

 

    React.useEffect(() => {
       // calculateDays(); // only called once
    });


    function calculateDays() {
        let availDate = (dayjs(props.PickupRequest.CustomerDateAvailableForPickup.Data));
        let startDate = dayjs();

        if (availDate >= dayjs()) {
            startDate = dayjs(availDate);
        }
        else {
            startDate = dayjs();
        }

        if (props.PickupRequest.LocationType === 'Business' && (props.PickupRequest.SunHours != '' || props.PickupRequest.MonHours != '' || props.PickupRequest.TueHours != '' || props.PickupRequest.WedHours != '' || props.PickupRequest.ThuHours != '' || props.PickupRequest.FriHours != '' || props.PickupRequest.SatHours != '')) {

           
            let currentTime = dayjs();
            // find the next available date
            while (pickup1 == null) {
                if (props.PickupRequest.SunHours != '' && startDate.day() == 0) {
                    if (startDate.date() == dayjs().date()) {
                        // check if we're before the closing time
                        let endHours = props.PickupRequest.SunHours.split(' to ')[1];
                        let closingTime = dayjs().set('hour', parseInt(endHours.split(':')[0])).set('minute', parseInt(endHours.split(':')[1])).set('second', 0);
                        if (currentTime.isBefore(closingTime)) {
                            pickup1 = dayjs(startDate);
                        }
                        else {
                            startDate = startDate.add(1, 'day');// add a day
                        }
                    }
                    else {
                        pickup1 = dayjs(startDate);
                    }
                }
                else if (props.PickupRequest.MonHours != '' && startDate.day() == 1) {
                    if (startDate.date() == dayjs().date()) {
                        // check if we're before the closing time
                        let endHours = props.PickupRequest.MonHours.split(' to ')[1];
                        let closingTime = dayjs().set('hour', parseInt(endHours.split(':')[0])).set('minute', parseInt(endHours.split(':')[1])).set('second', 0);
                        if (currentTime.isBefore(closingTime)) {
                            pickup1 = dayjs(startDate);
                        }
                        else {
                            startDate = startDate.add(1, 'day');// add a day
                        }
                    }
                    else {
                        pickup1 = dayjs(startDate);
                    }
                }
                else if (props.PickupRequest.TueHours != '' && startDate.day() == 2) {
                    if (startDate.date() == dayjs().date()) {
                        // check if we're before the closing time
                        let endHours = props.PickupRequest.TueHours.split(' to ')[1];
                        let closingTime = dayjs().set('hour', parseInt(endHours.split(':')[0])).set('minute', parseInt(endHours.split(':')[1])).set('second', 0);
                        if (currentTime.isBefore(closingTime)) {
                            pickup1 = dayjs(startDate);
                        }
                        else {
                            startDate = startDate.add(1, 'day');// add a day
                        }
                    }
                    else {
                        pickup1 = dayjs(startDate);
                    }
                    
                }
                else if (props.PickupRequest.WedHours != '' && startDate.day() == 3) {
                    if (startDate.date() == dayjs().date()) {
                        // check if we're before the closing time
                        let endHours = props.PickupRequest.WedHours.split(' to ')[1];
                        let closingTime = dayjs().set('hour', parseInt(endHours.split(':')[0])).set('minute', parseInt(endHours.split(':')[1])).set('second', 0);
                        if (currentTime.isBefore(closingTime)) {
                            pickup1 = dayjs(startDate);
                        }
                        else {
                            startDate = startDate.add(1, 'day');// add a day
                        }
                    }
                    else {
                        pickup1 = dayjs(startDate);
                    }
                }
                else if (props.PickupRequest.ThuHours != '' && startDate.day() == 4) {
                    if (startDate.date() == dayjs().date()) {
                        // check if we're before the closing time
                        let endHours = props.PickupRequest.ThuHours.split(' to ')[1];
                        let closingTime = dayjs().set('hour', parseInt(endHours.split(':')[0])).set('minute', parseInt(endHours.split(':')[1])).set('second', 0);
                        if (currentTime.isBefore(closingTime)) {
                            pickup1 = dayjs(startDate);
                        }
                        else {
                            startDate = startDate.add(1, 'day');// add a day
                        }
                    }
                    else {
                        pickup1 = dayjs(startDate);
                    }
                }
                else if (props.PickupRequest.FriHours != '' && startDate.day() == 5) {
                    if (startDate.date() == dayjs().date()) {
                        // check if we're before the closing time
                        let endHours = props.PickupRequest.FriHours.split(' to ')[1];
                        let closingTime = dayjs().set('hour', parseInt(endHours.split(':')[0])).set('minute', parseInt(endHours.split(':')[1])).set('second', 0);
                        if (currentTime.isBefore(closingTime)) {
                            pickup1 = dayjs(startDate);
                        }
                        else {
                            startDate = startDate.add(1, 'day');// add a day
                        }
                    }
                    else {
                        pickup1 = dayjs(startDate);
                    }
                }
                else if (props.PickupRequest.SatHours != '' && startDate.day() == 6) {
                    if (startDate.date() == dayjs().date()) {
                        // check if we're before the closing time
                        let endHours = props.PickupRequest.SatHours.split(' to ')[1];
                        let closingTime = dayjs().set('hour', parseInt(endHours.split(':')[0])).set('minute', parseInt(endHours.split(':')[1])).set('second', 0);
                        if (currentTime.isBefore(closingTime)) {
                            pickup1 = dayjs(startDate);
                        }
                        else {
                            startDate = startDate.add(1, 'day');// add a day
                        }
                    }
                    else {
                        pickup1 = dayjs(startDate);
                    }
                }
                else {
                    startDate = startDate.add(1, 'day');// add a day
                }
            }

            startDate = dayjs(pickup1).add(1, 'day');// add a day
            // find the next available date
            while (pickup2 == null) {
                if (props.PickupRequest.SunHours != '' && startDate.day() == 0) {
                    pickup2 = dayjs(startDate);
                }
                else if (props.PickupRequest.MonHours != '' && startDate.day() == 1) {
                    pickup2 = dayjs(startDate);
                }
                else if (props.PickupRequest.TueHours != '' && startDate.day() == 2) {
                    pickup2 = dayjs(startDate);
                }
                else if (props.PickupRequest.WedHours != '' && startDate.day() == 3) {
                    pickup2 = dayjs(startDate);
                }
                else if (props.PickupRequest.ThuHours != '' && startDate.day() == 4) {
                    pickup2 = dayjs(startDate);
                }
                else if (props.PickupRequest.FriHours != '' && startDate.day() == 5) {
                    pickup2 = dayjs(startDate);
                }
                else if (props.PickupRequest.SatHours != '' && startDate.day() == 6) {
                    pickup2 = dayjs(startDate);
                }
                else {
                    startDate = startDate.add(1, 'day');// add a day
                }
            }

            startDate = dayjs(pickup2).add(1, 'day');// add a day
            // find the next available date
            while (pickup3 == null) {
                if (props.PickupRequest.SunHours != '' && startDate.day() == 0) {
                    pickup3 = dayjs(startDate);
                }
                else if (props.PickupRequest.MonHours != '' && startDate.day() == 1) {
                    pickup3 = dayjs(startDate);
                }
                else if (props.PickupRequest.TueHours != '' && startDate.day() == 2) {
                    pickup3 = dayjs(startDate);
                }
                else if (props.PickupRequest.WedHours != '' && startDate.day() == 3) {
                    pickup3 = dayjs(startDate);
                }
                else if (props.PickupRequest.ThuHours != '' && startDate.day() == 4) {
                    pickup3 = dayjs(startDate);
                }
                else if (props.PickupRequest.FriHours != '' && startDate.day() == 5) {
                    pickup3 = dayjs(startDate);
                }
                else if (props.PickupRequest.SatHours != '' && startDate.day() == 6) {
                    pickup3 = dayjs(startDate);
                }
                else {
                    startDate = startDate.add(1, 'day');// add a day
                }
            }

        }
        else {
            if (startDate.hour() >= 22) {
                startDate = dayjs(startDate).add(1, 'day');
            }
            pickup1 = dayjs(startDate);
            pickup2 = dayjs(startDate).add(1, 'day');
            pickup3 = dayjs(startDate).add(2, 'day');
        }

        setPickupDate1(pickup1);
        setPickupDate2(pickup2);
        setPickupDate3(pickup3);
    }

    function dateChanged(e) {
        
        let dateChosen = dayjs(e.target.value);
        setSelectedDate(dateChosen.format('MM/DD/YYYY'));
        let timesToChoose = [];
        let choseDateHours = '';
        if (props.PickupRequest.LocationType === 'Business' && (props.PickupRequest.SunHours != '' || props.PickupRequest.MonHours != '' || props.PickupRequest.TueHours != '' || props.PickupRequest.WedHours != '' || props.PickupRequest.ThuHours != '' || props.PickupRequest.FriHours != '' || props.PickupRequest.SatHours != '')) {
           

            let timeBlocks = [];
            let chosenDateHours = '';
            if (dateChosen.day() == 0) {
                choseDateHours = props.PickupRequest.SunHours;
            }
            else if (dateChosen.day() == 1) {
                choseDateHours = props.PickupRequest.MonHours;
            }
            else if (dateChosen.day() == 2) {
                choseDateHours = props.PickupRequest.TueHours;
            }
            else if (dateChosen.day() == 3) {
                choseDateHours = props.PickupRequest.WedHours;
            }
            else if (dateChosen.day() == 4) {
                choseDateHours = props.PickupRequest.ThuHours;
            }
            else if (dateChosen.day() == 5) {
                choseDateHours = props.PickupRequest.FriHours;
            }
            else if (dateChosen.day() == 6) {
                choseDateHours = props.PickupRequest.SatHours;
            }
            let startHours = choseDateHours.split(' to ')[0];
            let openHours = dayjs().set('hour', parseInt(startHours.split(':')[0])).set('minute', parseInt(startHours.split(':')[1])).set('second', 0);
            let endHours = choseDateHours.split(' to ')[1];
            let closingTime = dayjs().set('hour', parseInt(endHours.split(':')[0])).set('minute', parseInt(endHours.split(':')[1])).set('second', 0);
             // try to create 2 hour blocks
            let index = 0;
            while (openHours.isBefore(closingTime)) {
                index++;
                let start = openHours;
                let end = openHours.add(2, 'hour');

                if (end.isBefore(closingTime)) {
                    timesToChoose.push(<FormControlLabel key={'TimeValue' + index} value={start.format('hh:mma') + '_' + end.format('hh:mma')} control={<Radio />} label={start.format('hh:mma') + ' - ' + end.format('hh:mma')} />);
                }
                else {
                    timesToChoose.push(<FormControlLabel key={'TimeValue' + index} value={start.format('hh:mma') + '_' + closingTime.format('hh:mma')} control={<Radio />} label={start.format('hh:mma') + ' - ' + closingTime.format('hh:mma')} />);
                }
                openHours = end;
            }
        }
        else {
            let todayDay = dayjs().date();
            if (dayjs(dateChosen).date() == dayjs().date()) {
                let currentHour = dayjs().hour();

                if (currentHour < 10) {//Current time is less than equal to 10am.
                    timesToChoose.push(<FormControlLabel key='TimeValue1' value='6am_10am' control={<Radio />} label='6am - 10am' />);
                    timesToChoose.push(<FormControlLabel key='TimeValue2' value='10am_2pm' control={<Radio />} label='10am - 2pm' />);
                    timesToChoose.push(<FormControlLabel key='TimeValue3' value='2pm_6pm' control={<Radio />} label='2pm - 6pm' />);
                    timesToChoose.push(<FormControlLabel key='TimeValue4' value='6pm_10pm' control={<Radio />} label='6pm - 10pm' />);
                }
                else if (currentHour < 14) {//Current time is greater than equal to 2pm.
                   
                    timesToChoose.push(<FormControlLabel key = 'TimeValue1' value='10am_2pm' control={<Radio />} label='10am - 2pm' />);
                    timesToChoose.push(<FormControlLabel key='TimeValue2' value='2pm_6pm' control={<Radio />} label='2pm - 6pm' />);
                    timesToChoose.push(<FormControlLabel key='TimeValue3' value='6pm_10pm' control={<Radio />} label='6pm - 10pm' />);
                }
                else if (currentHour < 18) {//Current time is greater than equal to 6pm.
                    timesToChoose.push(<FormControlLabel key='TimeValue1' value='2pm_6pm' control={<Radio />} label='2pm - 6pm' />);
                    timesToChoose.push(<FormControlLabel key='TimeValue2' value='6pm_10pm' control={<Radio />} label='6pm - 10pm' />);
                }
                else if (currentHour < 22) {//Current time is greater than equal to 10pm.
                    timesToChoose.push(<FormControlLabel key='TimeValue1' value='6pm_10pm' control={<Radio />} label='6pm - 10pm' />);
                }
            }
             else {
                // show all time windows
                timesToChoose.push(<FormControlLabel key='TimeValue1' value='6am_10am' control={<Radio />} label='6am - 10am' />);
                timesToChoose.push(<FormControlLabel key='TimeValue2' value='10am_2pm' control={<Radio />} label='10am - 2pm' />);
                timesToChoose.push(<FormControlLabel key='TimeValue3' value='2pm_6pm' control={<Radio />} label='2pm - 6pm' />);
                timesToChoose.push(<FormControlLabel key='TimeValue4' value='6pm_10pm' control={<Radio />} label='6pm - 10pm' />);
            }
            
        }

        setAvailableTimes(timesToChoose);
        setSelectedTime(null);
        if (props.viewType !== undefined && props.viewType === 'Admin') {
            props.onScheduled(props.PickupRequest, null, null, null);
        }
        window.setTimeout(function () {
            scheduleButtonRef.current.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }, 200);
       
    }

    function timeChanged(e) {
        setSelectedTime(e.target.value);
        if (props.viewType !== undefined && props.viewType === 'Admin') {
            props.onScheduled(props.PickupRequest, selectedDate, e.target.value, null);
        }
    }

    if (pickupDate1 === null) {
       calculateDays();
    }

    function handleOnScheduled() {
        props.onScheduled(props.PickupRequest, selectedDate, selectedTime, props.claimToken);
        props.onClose();
    }

    function handleTimerExpired() {
        props.onClose();
    }

    const calculateRemainingTime = (timeRemaining) => {
        if (timeRemaining <= 0) {
          return { initialMinutes: 0, initialSeconds: 0 };
        }
      
        const initialMinutes = Math.floor(timeRemaining / 60);
        const initialSeconds = Math.floor(timeRemaining % 60);
      
        return { initialMinutes, initialSeconds };
      };

    let initialMinutes;
    let initialSeconds;
    
    if ( props.claimToken != null && props.claimToken != undefined)
        {
            let {min, sec} = calculateRemainingTime(props.claimToken.TimeRemaining);
            initialMinutes = min;
            initialSeconds = sec;
        }
   

    return (<div style={{ height:(props.viewType !== undefined && props.viewType === 'Admin' ? 'auto' :'90vh'), width: '100%', display: 'flex', flexDirection: 'column', backgroundColor: '#f5f5f5' }}>
        {props.viewType != undefined && props.viewType === 'Admin' ? null :
            <div className={styles.SlideDrawerHeader}>
                <span style={{ marginRight: 'auto', alignSelf: 'center' }}>&nbsp;</span>
                <span>{props.PickupRequest.Status_Reason == 'Scheduled' ? 'Reschedule' : 'Scheduling'}</span>
                <IconButton onClick={() => props.onClose(false)} style={{ marginLeft: 'auto' }}><ExpandMoreIcon /></IconButton>
            </div>
        }
       
        <div style={{ maxHeight: '80vh', overflow: 'auto' }}>
        {props.claimToken != null &&
            <Card style={{ margin: '5px', maxWidth: '500px', marginLeft: 'auto', marginRight: 'auto' }}>
                <CardContent >
                    <div style={{ display: 'flex', justifyContent: 'center' }}>
                        <AlarmOnIcon sx={{ fontSize: 40, color: 'var(--sipzee-green)', alignSelf: 'center', marginRight:'5px' }} />
                        <div>
                            <div style={{ alignSelf: 'center' }}>You have claimed this pickup.</div>
                            <div style={{ alignSelf: 'center' }}><span style={{fontWeight:'bold'}}><CountdownTimer timerExpired={handleTimerExpired} initialMinutes={initialMinutes} initialSeconds={initialSeconds}  /></span> mins remaining to schedule it.</div>
                        </div>
                    </div>
                    <div style={{marginTop:'3px', fontStyle:'italic', textAlign:'center'}}>
                        Nobody else can schedule it during this time.
                    </div>


                </CardContent>
            </Card>
        }
            {props.viewType != undefined && props.viewType === 'Admin' ? null :
                <Card style={{ margin: '5px', maxWidth: '500px', marginLeft: 'auto', marginRight: 'auto' }}>
                    <CardContent >
                        <div style={{ display: 'flex', justifyContent: 'center' }}>
                            <NotificationImportantIcon sx={{ fontSize: 40, color: 'var(--sipzee-red)', alignSelf: 'center' }} />
                            <div style={{ alignSelf: 'center' }}>Note: This schedule will be automatically sent to the customer. It is important you complete this pickup on the date and within the time frame you commit to.</div>
                        </div>


                    </CardContent>
                </Card>
            }
            <Card style={{ marginTop: '10px', marginLeft: 'auto', marginRight: 'auto', width: '300px' }}>
                <CardContent>
                    <div style={{ alignSelf: 'center' }}>
                        <div style={{ fontWeight: 'bold', display: 'flex' }}>
                            {selectedDate === null ?
                                <EventIcon sx={{ fontSize: 40, color: 'var(--sipzee-yellow)' }} />
                                :
                                <EventAvailableIcon sx={{ fontSize: 40, color: 'var(--sipzee-green)' }} />
                            }
                            <div style={{ alignSelf: 'center', marginLeft: '15px' }}>Select a Pickup Date</div>
                        </div>
                        <RadioGroup
                            aria-labelledby="demo-controlled-radio-buttons-group"
                            name="controlled-radio-buttons-group"
                            value={selectedDate}
                            onChange={(e) => dateChanged(e)}
                            style={{ marginLeft: '50px' }}
                        >

                            <FormControlLabel value={pickupDate1 === null ? null : pickupDate1.format('MM/DD/YYYY')} control={<Radio />} label={pickupDate1 === null ? null : pickupDate1.format('ddd, MMM DD')} />
                            <FormControlLabel value={pickupDate2 === null ? null : pickupDate2.format('MM/DD/YYYY')} control={<Radio />} label={pickupDate2 === null ? null : pickupDate2.format('ddd, MMM DD')} />
                            <FormControlLabel value={pickupDate3 === null ? null : pickupDate3.format('MM/DD/YYYY')} control={<Radio />} label={pickupDate3 === null ? null : pickupDate3.format('ddd, MMM DD')} />
                        </RadioGroup>
                    </div>
                </CardContent>
            </Card>

            <Fade in={selectedDate !== null}>
                <Card style={{ marginTop: '10px', marginLeft: 'auto', marginRight: 'auto', width: '300px' }}>
                    <CardContent>
                        <div style={{ alignSelf: 'center', marginTop: '10px' }}>
                            <div style={{ fontWeight: 'bold', display: 'flex' }}>
                                {selectedDate === null ?
                                    <ScheduleIcon sx={{ fontSize: 40, color: 'var(--sipzee-yellow)' }} />
                                    :
                                    <ScheduleIcon sx={{ fontSize: 40, color: 'var(--sipzee-green)' }} />
                                }
                                <div style={{ alignSelf: 'center', marginLeft: '15px' }}>Select a Time Window</div>
                            </div>

                            <RadioGroup
                                aria-labelledby="demo-controlled-radio-buttons-group"
                                name="controlled-radio-buttons-group"
                                value={selectedTime}
                                onChange={(e) => timeChanged(e)}
                                style={{ marginLeft: '50px' }}
                            >
                                {availableTimes}
                            </RadioGroup>
                        </div>
                    </CardContent>
                </Card>
            </Fade>

            {props.viewType != undefined && props.viewType === 'Admin' ? null :
                <div style={{ display: 'flex', justifyContent: 'center', marginTop: '15px' }}>
                    <Button ref={scheduleButtonRef} variant='outlined' disabled={selectedTime === null} sx={{ backgroundColor: (selectedTime === null ? 'var(--sipzee-gray-3)' : 'var(--sipzee-green)') }} onClick={(e) => handleOnScheduled()}>Schedule</Button>
                </div>
            }

        </div>
    </div>)
}

export default Scheduler;